"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePoolSale = exports.usePoolCurrency = exports.usePoolToken = void 0;
var usePool_1 = require("../../pool/hooks/usePool");
function usePoolToken() {
    var _a = (0, usePool_1.usePool)(), pool = _a.pool, tokenInstance = _a.tokenInstance;
    return [pool.token, tokenInstance];
}
exports.usePoolToken = usePoolToken;
function usePoolCurrency() {
    var _a = (0, usePool_1.usePool)(), pool = _a.pool, fundTokenInstance = _a.fundTokenInstance;
    return [pool.fundToken, fundTokenInstance];
}
exports.usePoolCurrency = usePoolCurrency;
function usePoolSale() {
    var _a = (0, usePool_1.usePool)(), pool = _a.pool, saleInstance = _a.saleInstance;
    return [pool.sale, saleInstance];
}
exports.usePoolSale = usePoolSale;
